import { motion } from 'framer-motion';
import { DOWNLOAD_LINK, heroCopy } from '../../data/landingData';
import { fadeInUp, staggerContainer } from '../../utils/motion';
import { Button } from '../ui/Button';

export function HeroSection() {
  return (
    <section id="inicio" className="relative overflow-hidden pb-16 pt-6 sm:pb-20">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/fondo-header.png')" }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-hero-overlay" aria-hidden="true" />

      <motion.div
        className="container-base relative z-10 flex min-h-[68vh] items-center justify-center py-10 sm:min-h-[78vh] sm:py-14 lg:min-h-[82vh]"
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.div
          variants={fadeInUp}
          transition={{ duration: 0.45 }}
          className="mx-auto flex max-w-3xl flex-col items-center text-center"
        >
          <h1 className="mt-4 heading-display text-balance">{heroCopy.title}</h1>
          <p className="mt-4 max-w-2xl text-balance text-base leading-relaxed text-slate-700 sm:text-lg">
            {heroCopy.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button href={DOWNLOAD_LINK} target="_blank" rel="noreferrer">
              {heroCopy.primaryCta}
            </Button>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
